import { Row } from '@digital/ui'
import { Input } from 'antd'
import React, { useState } from 'react'
interface PropsModal {
    texto: string
    setJustificativa: (e: string) => void
}

const ModalConfirmContentJustificativa = (props: PropsModal) => {
    const [temp, setTemp] = useState('')
    const {
        texto,
        setJustificativa,
    } = props

    const onChange = (e: any) => {
        setJustificativa(e)
        setTemp(e)
    }

    return (
        <>
            <Row>
                <p>{texto}</p>
                <Input.TextArea name='justificativa' value={temp} onChange={e => onChange(e.currentTarget.value)} />
            </Row>
        </>
    )
}

export default ModalConfirmContentJustificativa